export const FETCH_SEARCH_FEED_LIST = 'FETCH_SEARCH_FEED_LIST';

export const fetchSearchFeedList = (action) => ({
  type: FETCH_SEARCH_FEED_LIST,
  action
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/actions.js
 **/